module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid61_1020x840.99f7345.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid61_1020x840.jpg
// module id = rw4S
// module chunks = 0